import { Button, Flex, ScrollArea, Text } from '@mantine/core';
import * as React from 'react';

import MarkdownRenderer from '@/components/ui/MarkdownRenderer';
import { PdfDocumentNote } from '@/stores/local/shared/PdfNotesStore';
import { formatDate } from '@/utils/formatDate';

import s from './DocumentNoteDetail.module.scss';

type DocumentNoteDetailProps = {
  note: PdfDocumentNote;
  onOpenPage: (note: PdfDocumentNote) => void;
};

const DocumentNoteDetail: React.FC<DocumentNoteDetailProps> = ({ note, onOpenPage }) => {
  const handleOpenPageClick = React.useCallback(() => {
    onOpenPage(note);
  }, [note, onOpenPage]);

  const isAiSummary = Boolean(note.isAiDocumentSummary);

  return (
    <Flex direction="column" gap="md" className={s.root__detail}>
      <Flex justify="space-between" align="center">
        <Text fw={700} size="md" className={s.root__caption}>
          {note.caption}
        </Text>
        {!isAiSummary && (
          <Text size="xs" c="dimmed">
            стр. {note.pageNumber}
          </Text>
        )}
      </Flex>
      <Text size="xs" c="dimmed">
        {isAiSummary ? `Обновлено: ${formatDate(note.updatedAt)}` : `Изменено: ${formatDate(note.updatedAt)}`}
      </Text>
      <ScrollArea.Autosize className={s.root__scroll} mah="100%" scrollbarSize={6} offsetScrollbars>
        <MarkdownRenderer content={note.text} paddingBottom />
      </ScrollArea.Autosize>
      {!isAiSummary && (
        <Button variant="light" onClick={handleOpenPageClick}>
          Открыть страницу
        </Button>
      )}
    </Flex>
  );
};

export default React.memo(DocumentNoteDetail);
